import React from 'react';
import styled from 'styled-components';

export const NewActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

